export default "__VITE_ASSET__Bz0$YgFN__"